/**
 * 表单控件的maker的公共方法
 * wangz
 * 2018.3.9
 */

"use strict"
import React from 'react';
import ReactDOM from 'react-dom';
import { message } from 'antd';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { SgiEventHandler } from './SgiEventHandler';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { funStrCheck } from 'rt-sd-common/sgiCommon/sgiCommon';
import { getConstByKey, setFunction } from './sgiBaseComp/SgiCommon';

/**
 * 绑定显示值
 * @param {描述信息} currentModule
 * @param {描述信息} moduleDesc
 * @param {数据} bdInst
 * @param {对象工厂} objFct
 * @param {属性} formItem
 * @param {属性} inputprops
 */
var bindValue = function (currentModule, moduleDesc, bdInst, objFct, formItem, inputprops, checked) {

    if (!moduleDesc.c) {
        return;
    }

    //currentModule.bdInst = bdInst;
    var attname = moduleDesc.c;
    currentModule.state.attname = attname;

    var bdInstValue;
    if (!bdInst || !objFct) return;

    if (typeof bdInst === "string") {
        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
        if (currentModule.props.type === 'tb') {
            const bdInstKeyList = bdInst.split('`');
            const bdInstList = objFct.get(bdInstKeyList[0]);
            if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
            }
        } else {
            bdInstValue = objFct.get(bdInst);
        }
    } else {
        bdInstValue = bdInst;
    }

    // 带点./[/]解析
    let evalFlg = RegExp(/[.|\[|\]]+/).test(attname);
    let valueFlg = evalFlg && eval(`(bdInstValue.${attname})`) !== undefined;

    if (bdInstValue && (bdInstValue[attname] !== undefined || valueFlg)) {//2018.04.27-yly,有value会导致默认值无法赋值
        let value;
        if (evalFlg) {
            // 带层级解析，catch防止中断
            try {
                value = eval(`(bdInstValue.${attname})`);
            } catch (error) {
                sgiLogger.error(`属性名解析出错，当前属性名${attname}`);
                sgiLogger.eventErr(error);
            }
        } else value = bdInstValue[attname];
        //给checkbox 使用
        if (checked) {
            let _checked = value ? true : false;
            let escape = currentModule.state.escape;
            if (escape) {//转义
                let escs = escape.split("/");
                _checked = (value === escs[0]);
            }
            inputprops.checked = _checked;
            inputprops.value = value;
        } else {
            inputprops.value = value;
        }
    } else {//20180704 wzhe 默认值 给当前value
        inputprops.value = inputprops.defaultValue;
        if (bdInstValue) {
            if (evalFlg) {
                // 带层级解析，catch防止中断
                try {
                    eval(`(bdInstValue.${attname} = inputprops.defaultValue)`);
                } catch (error) {
                    sgiLogger.error(`属性名解析出错，当前属性名${attname}`);
                    sgiLogger.eventErr(error);
                }
            } else bdInstValue[attname] = inputprops.defaultValue;
        }
    }

    // if (bdInstValue && bdInstValue[attname]) {//2018.04.27-yly,有value会导致默认值无法赋值
    //     //给checkbox 使用
    //     if (checked) {
    //         // inputprops.checked = bdInstValue[attname] ? true : false;
    //         let value = bdInstValue[attname];
    //         let checked = value ? true : false;
    //         let escape = currentModule.state.escape;
    //         if (escape) {//转义
    //             let escs = escape.split("/");
    //             checked = (value === escs[0]);
    //         }
    //         inputprops.checked = checked;
    //         inputprops.value = value;
    //     } else {
    //         inputprops.value = bdInstValue[attname];
    //     }
    // } else {//20180704 wzhe 默认值 给当前value
    //     inputprops.value = inputprops.defaultValue;
    //     if (bdInstValue) {
    //         bdInstValue[attname] = inputprops.defaultValue;
    //     }
    // }
}

/**
 * 属性转换
 * @param {描述信息} currentModule
 * @param {描述信息} moduleDesc
 * @param {属性} formItem
 * @param {属性} inputprops
 */
var AddFormCtlCommonAttribute = function (currentModule, moduleDesc, formItem, inputprops) {
    // label样式回显
    const isLabel = moduleDesc.isLabel;
    currentModule.state.isLabel = !!isLabel;
    if (isLabel) formItem.colon = true;// 显示冒号

    var cId = moduleDesc.cId; //cid 唯一标示
    if (cId) inputprops.id = getConstByKey(currentModule, cId);

    var isDis = moduleDesc.isDis; //是否可用
    inputprops.disabled = isDis;

    var isRead = moduleDesc.isRead; //是否只读
    // inputprops.style.readonly = 'expression(this.readonly = true)';
    inputprops.readOnly = !!isRead;

    if (moduleDesc.te || moduleDesc.teid) {//避免不必要的执行getTRByPrm()方法
        var text = Resource.getTRByPrm(moduleDesc).te; //设置标签
        if (text) formItem.label = text;
    }

    var ctlW = moduleDesc.ctlW; //控件宽度
    // if (ctlW) formItem.style.width = ctlW;

    var ctlH = moduleDesc.ctlH; //控件高度
    if (ctlH) {
        formItem.style.height = ctlH;
        inputprops.style.height = ctlH;//输入框也随着高度变动
    } else {
        formItem.style.height = undefined;//编辑的时候即时刷新，也可以不加
        inputprops.style.height = undefined;//编辑的时候即时刷新，也可以不加
    }

    var lblW = moduleDesc.lblW; //设置标签宽度

    if (ctlW && lblW) {
        var lblWSpan = parseInt(lblW / ctlW * 24)
        var wrapperSpan = 24 - lblWSpan;
        formItem.labelCol = { span: lblWSpan }
        formItem.wrapperCol = { span: wrapperSpan }
    } else {
        formItem.labelCol = { span: 6 }
        formItem.wrapperCol = { span: 18 }
    }

    var isLbl = moduleDesc.isLbl; //设置是否隐藏标签
    if (isLbl) {
        formItem.label = undefined;
        formItem.labelCol = { span: 0 }
        formItem.wrapperCol = { span: 24 }
    }

    var inpPopTe = moduleDesc.inpPopTe; //提示内容
    if (inpPopTe) inputprops.placeholder = getConstByKey(currentModule, inpPopTe);

    var defVal10 = moduleDesc.defVal10; //默认内容
    if (defVal10 !== undefined) inputprops.defaultValue = defVal10;//数字控件是可以有0的，所以别用!判定

    var bdText = moduleDesc.bdText; //后置内容
    if (bdText) inputprops.addonAfter = bdText;

    var alwBlk = moduleDesc.alwBlk; //是否允许为空
    formItem.required = !alwBlk;
    currentModule.state.validRules.required = !alwBlk;
    currentModule.state.required = !alwBlk;
    if (isLabel) {//仅回显状态不校验
        formItem.required = false;
        currentModule.state.validRules.required = false;
        currentModule.state.required = false;
    }
    // if (!alwBlk) {
    //     formItem.required = !alwBlk;
    //     currentModule.state.validRules.required = !alwBlk;
    // } else {
    //     formItem.required = !alwBlk;
    //     currentModule.state.validRules.required = !alwBlk;
    // }

    if (moduleDesc.vldC) currentModule.state.validRules.dataType = moduleDesc.vldC;

    var maxL = moduleDesc.maxL; //设置字段输入的最大长度
    if (maxL) currentModule.state.validRules.maxL = maxL;
    else currentModule.state.validRules.maxL = undefined;
    var minL = moduleDesc.minL; //设置字段输入的最小长度
    if (minL) currentModule.state.validRules.minL = minL;
    else currentModule.state.validRules.minL = undefined;

    let vldC = moduleDesc.vldC;
    if (vldC && (vldC === "int" || vldC === "double" || vldC === "money" || vldC === "number")) {
        var maxV = moduleDesc.maxV; //设置字段输入的最大值
        if (maxV) currentModule.state.validRules.maxV = maxV;
        else currentModule.state.validRules.maxV = undefined;
        var minV = moduleDesc.minV; //设置字段输入的最小值
        if (minV) currentModule.state.validRules.minV = minV;
        else currentModule.state.validRules.minV = undefined;
    }

    var isHdn = moduleDesc.isHdn; //是否隐藏
    if (isHdn) {
        formItem.style.display = "none"
    } else {
        formItem.style.display = undefined;
    }

    inputprops.nowrap = !!moduleDesc.nowrap;

    // form属性
    currentModule.state._formProps = moduleDesc._formProps || {};

    var lblAlg = moduleDesc.lblAlg; //设置标签对齐方式??没实现
    var isClp = moduleDesc.isClp; //设置是否根据内容字段进行伸展和收缩??没实现
    var msfTgt = moduleDesc.msfTgt; //设置错误信息提示位置??没实现

    // var prefix = moduleDesc.prefix;//前缀图
    // if (prefix) inputprops.prefix = prefix;

    // 自定义样式
    let cstmStyle = moduleDesc.cstmStyle;
    let $cstmStyle;
    if (cstmStyle) {
        try {
            $cstmStyle = new Function("module", "objFct", cstmStyle);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        // currentModule.state.cstmStyle = $cstmStyle;
        setFunction(currentModule, "cstmStyle", $cstmStyle);
    }

    currentModule.state.showCheck = moduleDesc.showCheck;

    // 自定义校验规则
    let cstmValid = moduleDesc.cstmValid;
    let $cstmValid;
    if (cstmValid) {
        try {
            $cstmValid = new Function("module", "objFct", "value", cstmValid);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        currentModule.state.validRules.cstmValid = $cstmValid;
    }

}

/**
 * 设置布局
 * @param {描述信息} moduleDesc
 * @param {属性} formItem
 * @param {属性} inputprops
 */
var setFormCtlLayout = function (moduleDesc, formItem, inputprops) {


}


/**
 * 事件转换
 * @param {描述信息} currentModule
 * @param {描述信息} moduleDesc
 * @param {对象工厂} objFct
 * @param {属性} inputprops
 */
var bindEvent = function (currentModule, moduleDesc, objFct, inputprops, functions, type) {

    //拖拽模式 不生成事件
    if (type == 'dnd') {
        return;
    }

    //onchange
    var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
    if (chgLsn) {
        var $chgLsn;
        try {
            $chgLsn = new Function("module", "objFct", "record", "nv", "nt", "itemData", "extra", chgLsn);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        functions.onChange = $chgLsn;
    }
    inputprops.onChange = SgiEventHandler.onChange.bind(this, currentModule);

    //onFocus
    var inLsn = moduleDesc.inLsn; // 用户自定义点击事件
    if (inLsn) {
        var $inLsn;
        try {
            $inLsn = new Function("module", "objFct", inLsn);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        functions.onFocus = $inLsn;
        inputprops.onFocus = SgiEventHandler.onFocus.bind(this, currentModule);
    }

    //onBlur
    var lveLsn = moduleDesc.lveLsn; // 用户自定义点击事件
    if (lveLsn) {

        var $lveLsn;
        try {
            $lveLsn = new Function("module", "objFct", lveLsn);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        functions.onBlur = $lveLsn;
        inputprops.onBlur = SgiEventHandler.onBlur.bind(this, currentModule);
    }

    // 自定义渲染组件
    const cstmRender = moduleDesc.cstmRender;
    if (funStrCheck(cstmRender)) {
        let $cstmRender;
        try {
            $cstmRender = new Function("module", "inputprops", "value", "objFct", cstmRender);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        functions.cstmRender = $cstmRender;
    }

    // //onInput
    // inputprops.onInput = function() {
    //     message.info('获取焦点事件');
    // }
    // //点击事件
    // inputprops.onClick = function () {
    //     message.info('点击事件');
    // }
    // //双击事件
    // inputprops.onDoubleClick = function () {
    //     message.info('双击事件');
    // }
    // //onCopy
    // inputprops.onCopy = function () {
    //     message.info('复制事件');
    // }
    // //onCut
    // inputprops.onCut = function () {
    //     message.info('剪切事件');
    // }
    // //onPaste
    // inputprops.onPaste = function () {
    //     message.info('粘贴事件');
    // }
}
export { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute };
export default { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute };



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormCtlComm.js